// extracted by mini-css-extract-plugin
export default {"monthly":"item_monthly__rtjyy","grand":"item_grand__eAI1m","surprise":"item_surprise__7TSWz"};